
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 640"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M320 64c-17.7 0-32 14.3-32 32v3.2C215 114 160 178.6 160 256v21.7c0 48.1-16.4 94.8-46.4 132.4l-9.8 12.2c-5.1 6.3-7.8 14.1-7.8 22.2 0 19.6 15.9 35.5 35.5 35.5h376.9c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-9.8-12.2c-29.9-37.6-46.3-84.3-46.3-132.4V256c0-77.4-55-142-128-156.8V96c0-17.7-14.3-32-32-32zm-62 464c7.1 27.6 32.2 48 62 48 29.8 0 54.9-20.4 62-48H258z"}})])
          )
        }
      }
    